"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastNDaysStart = lastNDaysStart;
/**
 * "Last N days" windows (BEN-141 FP-122, Paul 2026-10-06).
 *
 * "Last 7 days" is today plus the 6 days before it: seven days in all, and the
 * same rule for 30 and 90. Both clients counted back N days and then included
 * today, so "Last 7 days" covered eight days and its totals took in an extra
 * day's spending. TXN-S04 had described that behaviour, not argued for it, and
 * is superseded.
 *
 * Pure date arithmetic on `YYYY-MM-DD`: the caller passes its own LOCAL today,
 * so no UTC parsing can move the window by a day (the TXN-S04 slip).
 */
function lastNDaysStart(days, today) {
    if (!Number.isInteger(days) || days < 1) {
        throw new RangeError(`lastNDaysStart: days must be a whole number ≥ 1, got ${days}`);
    }
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(today);
    if (!m)
        throw new RangeError(`lastNDaysStart: expected YYYY-MM-DD, got ${today}`);
    const t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) - (days - 1));
    const d = new Date(t);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
}
//# sourceMappingURL=dateWindow.js.map